export default '/build/1ba7d1a8.svg'